function getConfigurationCredentials(_this,meta,license_no){
    if(meta != 'vue'){
        window.api.send('fetch_license_messege'); 
        window.api.receive("fetch_license_reply", (user_config_obj,license) => {
            if(license == license_no){
                    _this.is_valid_license = true;
            }
        });
    }
    else{

    }
}

// function getLicenseCredentials(meta,license_no){
//     console.log(meta);
//     if(meta != 'vue'){
//         window.api.send('fetch_user_configuration_messege'); 
//         window.api.receive("fetch_user_configuration_reply", (config_obj) => {
//             console.log(config_obj);
//         });
//     }
//     else{
//     }
// }

export{getConfigurationCredentials}